export default function Header({ user }) {
  return (
    <header className="flex items-center justify-between py-2">
      <div>
        <p className="text-sm text-tg-hint">Welcome back</p>
        <h1 className="text-2xl font-black">{user?.first_name || "Creator"}</h1>
      </div>
      <div className="grid h-11 w-11 place-items-center rounded-app bg-violet-600 font-black">{(user?.first_name || "B")[0]}</div>
    </header>
  );
}
